export const MAPBOX_TOKEN = import.meta.env.VITE_MAPBOX_TOKEN;

export const MAP_ACTIONS = {
    MAP: "Map",
    ADD: "Add",
    SELECT: "Select",
  };
  